import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { UsersHttpClient } from '@omnea-app/users/usersHttpClient'
import { listGroupsQueryKey } from './groupsQueryKeys'

export const useListGroups = () => {
  const { getToken } = useAuthenticatedUser()
  return useQuery({
    queryKey: [listGroupsQueryKey],
    queryFn: async () => {
      const token = await getToken()
      const apiClient = new UsersHttpClient({ omneaJwt: token })
      const { data } = await apiClient.GET('/groups/list')
      return data
    },
  })
}
